import React from 'react'
import './footer.css'
import {AiFillLinkedin} from 'react-icons/ai'
import {IoLogoTwitter} from 'react-icons/io'
import {ImGithub} from 'react-icons/im'
import {AiFillBehanceSquare} from 'react-icons/ai'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'></a>

      <ul className='permalinks'>
      <li><a href="#">Home</a></li>
      <li><a href="#about">About</a></li>
      <li><a href="#experience">Experience</a></li>
      <li><a href="#portfolio">Portfolio</a></li>
      <li><a href="#testimonials">Testimonials</a></li>
      <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/prateek-arora-917782191/" target='_blank'><AiFillLinkedin /></a>
        <a href="https://twitter.com/_prateekarora" target='_blank'><IoLogoTwitter /></a>
        <a href="https://github.com/prateekarora0819" target='_blank'><ImGithub /></a>
        <a href="https://www.behance.net/prateekarora7" target='_blank'><AiFillBehanceSquare /></a>
      </div>

      <div className="footer__copyright">
      <small>&copy; Prateek Arora</small>

      </div>
    </footer>
  )
}

export default Footer